import { debounce } from "~/utils/debounce.util"

export const setupNavigationVisibility = (): void => {
  let lastScrollTop = 0
  const scrollThreshold = 100
  const mainNavigation = document.querySelector("#main-navigation") as HTMLElement

  const handleScroll = () => {
    const navigationExpanded = document.querySelector('.accordion-active[aria-expanded="true"]') as HTMLElement
    const scrollTop = window.scrollY || document.documentElement.scrollTop

    if (scrollTop > lastScrollTop) {
      if (scrollTop > scrollThreshold && !navigationExpanded) {
        mainNavigation.style.transform = "translateY(-100%)"
      }
    } else {
      mainNavigation.style.transform = "translateY(0)"
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
  }
  window.addEventListener(
    "scroll",
    debounce(() => {
      handleScroll()
    }, 10)
  )
}
